import { extendTheme } from "@chakra-ui/react";

const theme = {
  fonts: {
    heading: '"Outfit", system-ui, sans-serif',
    body: '"DM Sans", system-ui, sans-serif',
  },
  colors: {
    accent: {
      50: "#e6fffa",
      100: "#b2f5ea",
      200: "#81e6d9",
      300: "#4fd1c5",
      400: "#38b2ac",
      500: "#319795",
      600: "#2c7a7b",
      700: "#285e61",
      800: "#234e52",
      900: "#1d4044",
    },
  },
  styles: {
    global: (props: { colorMode: string }) => ({
      "html, body": {
        minHeight: "100%",
        bg: props.colorMode === "dark" ? "gray.900" : "gray.50",
        color: props.colorMode === "dark" ? "gray.100" : "gray.800",
      },
      "body": {
        fontFeatureSettings: '"ss01", "ss02"',
      },
    }),
  },
  config: {
    initialColorMode: "dark" as const,
    useSystemColorMode: false,
  },
  components: {
    Link: {
      baseStyle: {
        _focus: { boxShadow: "none" },
      },
    },
    Button: {
      baseStyle: {
        _focus: { boxShadow: "none" },
      },
    },
  },
};

export default extendTheme(theme);
